export default __webpack_public_path__ + "static/arizona-technology-council-partner-0d41d4684717abe793a41943cb0daa0b.png";